module.exports = __webpack_public_path__ + "img/3-2.94b3c216.png";